import { Injectable } from '@angular/core';
import {HttpClient} from '@node_modules/@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionTypeService {

  constructor(
    private httpClient: HttpClient,
  ) { }

  getAllSubscriptionTypes() {
    return this.httpClient.get('subscriptionType');
  }
}
